<template>
  <div
    id="form-survey"
    :class="'animated fadeIn survey-id-' + mData.dataForm.survey.id"
  >
    <div class="card state-loading" v-if="formState == 'loading'">
      <div class="card-header survey-name">
        <div class="survey-description-holder">
          {{ aLang.SurveyResultUser_loading_title }}
        </div>
      </div>
      <div class="card-body survey-description">
        <b-row>
          <b-col class="survey-description-holder text-center">{{
            aLang.SurveyResultUser_loading_message
          }}</b-col>
        </b-row>
      </div>
    </div>
    <div class="card state-error" v-if="formState == 'error'">
      <div class="card-header survey-name">
        <div class="survey-description-holder">{{ error.title }}</div>
      </div>
      <div class="card-body survey-description">
        <b-row>
          <b-col class="survey-description-holder">{{ error.message }}</b-col>
        </b-row>
      </div>
    </div>

    <div class="card state-shown" v-if="formState == 'shown'">
      <div class="card-header survey-name">
        <div class="survey-description-holder">
          {{ mData.dataForm.survey.name }}
        </div>
      </div>
      <div class="card-body survey-description">
        <b-row>
          <b-col class="survey-description-holder">{{
            mData.dataForm.survey.description
          }}</b-col>
        </b-row>
      </div>
    </div>
    <div class="card mb-0 state-shown" v-if="formState == 'shown'">
      <div class="card-body">
        <el-form
          :model="mData.dataFormRender"
          :rules="mData.validFormRender"
          ref="myForm"
          class="w-100"
          label-width="50%"
          label-position="top"
        >
          <b-row
            v-for="item in mData.dataForm.surveyItems"
            :key="item.code"
            :class="
              (item.inputControl == 'hidden' ? 'hidden' : '') +
              ' survey-item-code-' +
              item.code
            "
          >
            <b-col class="survey-item" v-if="item.inputControl === 'number'">
              <el-form-item :label="item.title" :prop="item.code">
                <el-input-number
                  :id="item.code"
                  v-model="mData.dataFormRender[item.code]"
                  :disabled="
                    mData.dataDefault.viewMode == 'detail' ||
                    mData.dataDefault.viewMode == 'view' ||
                    item.isDisable
                  "
                ></el-input-number>
              </el-form-item>
            </b-col>
            <b-col
              class="survey-item"
              v-if="
                (item.inputControl === 'textbox' ||
                  item.inputControl === 'email') &&
                mData.visibleSurveyItem[item.code]
              "
            >
              <el-form-item :label="item.title" :prop="item.code">
                <el-input
                  :id="item.code"
                  v-model="mData.dataFormRender[item.code]"
                  :disabled="
                    mData.dataDefault.viewMode == 'detail' ||
                    mData.dataDefault.viewMode == 'view' ||
                    item.isDisable
                  "
                  @blur="fn_handleChangeOption(item)"
                ></el-input>
              </el-form-item>
            </b-col>
            <b-col
              class="survey-item"
              v-if="
                item.inputControl === 'hidden' &&
                mData.visibleSurveyItem[item.code]
              "
            >
              <el-form-item label="">
                <el-input
                  :id="item.code"
                  type="hidden"
                  v-model="mData.dataFormRender[item.code]"
                  :disabled="
                    mData.dataDefault.viewMode == 'detail' ||
                    mData.dataDefault.viewMode == 'view' ||
                    item.isDisable
                  "
                ></el-input>
              </el-form-item>
            </b-col>
            <b-col
              class="survey-item"
              v-if="
                item.inputControl === 'date' &&
                mData.visibleSurveyItem[item.code]
              "
            >
              <el-form-item :label="item.title" :prop="item.code">
                <el-date-picker
                  :id="item.code"
                  type="date"
                  :format="aElement.datepicker.formatDate"
                  :valueFormat="aElement.datepicker.valueFormat"
                  v-model="mData.dataFormRender[item.code]"
                  :placeholder="aElement.datepicker.placeholderDate"
                  clearable
                  :disabled="
                    mData.dataDefault.viewMode == 'detail' ||
                    mData.dataDefault.viewMode == 'view' ||
                    item.isDisable
                  "
                  @blur="fn_handleChangeOption(item)"
                ></el-date-picker>
              </el-form-item>
            </b-col>
            <b-col
              class="survey-item"
              v-if="
                item.inputControl === 'datetime' &&
                mData.visibleSurveyItem[item.code]
              "
            >
              <el-form-item :label="item.title" :prop="item.code">
                <el-date-picker
                  :id="item.code"
                  type="datetime"
                  :format="aElement.datepicker.formatDatetime"
                  :valueFormat="aElement.datepicker.valueFormat"
                  v-model="mData.dataFormRender[item.code]"
                  :placeholder="aElement.datepicker.placeholderDatetime"
                  clearable
                  :disabled="
                    mData.dataDefault.viewMode == 'detail' ||
                    mData.dataDefault.viewMode == 'view' ||
                    item.isDisable
                  "
                  @blur="fn_handleChangeOption(item)"
                ></el-date-picker>
              </el-form-item>
            </b-col>
            <b-col
              class="survey-item"
              v-if="
                item.inputControl === 'selectbox' &&
                mData.visibleSurveyItem[item.code]
              "
            >
              <el-form-item :label="item.title" :prop="item.code">
                <el-select
                  :id="item.code"
                  :multiple="item.isMultipleValue"
                  v-model="mData.dataFormRender[item.code]"
                  filterable
                  :placeholder="
                    item.placeholder
                      ? item.placeholder
                      : aLang.c_select + ' ' + item.title.toLowerCase()
                  "
                  :disabled="
                    mData.dataDefault.viewMode == 'detail' ||
                    mData.dataDefault.viewMode == 'view' ||
                    item.isDisable
                  "
                  @change="fn_handleChangeOption(item)"
                >
                  <el-option
                    v-for="option in mData.dataDefault.optionInputControls[
                      item.inputControl
                    ][item.code]"
                    :key="option.key"
                    :label="option.value"
                    :value="option.key | string"
                  ></el-option>
                </el-select>
              </el-form-item>
            </b-col>
            <b-col
              class="survey-item"
              v-if="
                item.inputControl === 'radio' &&
                mData.visibleSurveyItem[item.code]
              "
            >
              <el-form-item :label="item.title" :prop="item.code">
                <el-radio-group
                  :id="item.code"
                  v-model="mData.dataFormRender[item.code]"
                  :disabled="
                    mData.dataDefault.viewMode == 'detail' ||
                    mData.dataDefault.viewMode == 'view' ||
                    item.isDisable
                  "
                  @change="fn_handleChangeOption(item)"
                >
                  <el-radio
                    class="mr-5 mt-3 d-block"
                    v-for="option in mData.dataDefault.optionInputControls[
                      item.inputControl
                    ][item.code]"
                    :key="option.key"
                    :label="option.key"
                    :value="option.key"
                    >{{ option.value }}
                  </el-radio>
                </el-radio-group>
              </el-form-item>
            </b-col>
            <b-col
              class="survey-item"
              v-if="
                item.inputControl === 'checkbox' &&
                mData.visibleSurveyItem[item.code]
              "
            >
              <el-form-item :label="item.title" :prop="item.code">
                <!-- TODO: cấu hình hiển thị -->
                <el-checkbox
                  :label="aLang.SurveyResultUser_check_all"
                  @change="fn_checkAll(item.code)"
                  v-model="mData.checkAll[item.code]"
                >
                </el-checkbox>
                <el-checkbox-group
                  :id="item.code"
                  @change="fn_handleChangeOption(item)"
                  v-model="mData.dataFormRender[item.code]"
                  :disabled="
                    mData.dataDefault.viewMode == 'detail' ||
                    mData.dataDefault.viewMode == 'view' ||
                    item.isDisable
                  "
                >
                  <el-checkbox
                    v-for="option in mData.dataDefault.optionInputControls[
                      item.inputControl
                    ][item.code]"
                    :key="option.key"
                    :label="option.key"
                    :value="option.key"
                    >{{ option.value }}
                  </el-checkbox>
                </el-checkbox-group>
              </el-form-item>
            </b-col>
            <b-col
              class="survey-item"
              v-if="
                item.inputControl === 'label' &&
                mData.visibleSurveyItem[item.code]
              "
            >
              <el-form-item
                :label="item.title"
                v-if="
                  item.labelType != 'multipleline' &&
                  item.labelType != 'richtext'
                "
              ></el-form-item>
              <el-form-item
                :label="item.title"
                v-if="item.labelType === 'multipleline'"
              ></el-form-item>
              <el-form-item
                v-html="fn_convertMarkdownToHtml(item.title)"
                v-if="item.labelType == 'richtext'"
              ></el-form-item>
            </b-col>
            <b-col
              class="survey-item"
              v-if="
                item.inputControl === 'image' &&
                mData.visibleSurveyItem[item.code]
              "
            >
              <el-form-item :label="item.title" :prop="item.code">
                <div class="d-flex justify-content-center">
                  <el-col class="w-75">
                    <el-card :body-style="{ padding: '0px' }">
                      <img
                        :src="fn_getUrlImageById(item.fileId)"
                        class="image"
                      />
                      <div style="padding: 14px">
                        <span>{{ item.title }}</span>
                      </div>
                    </el-card>
                  </el-col>
                </div>
              </el-form-item>
            </b-col>
            <b-col
              class="survey-item"
              v-if="
                item.inputControl === 'map' &&
                mData.visibleSurveyItem[item.code]
              "
            >
              <el-form-item :label="item.title" :prop="item.code">
                <template
                  v-if="
                    (mData.dataDefault.viewMode == 'detail' ||
                      mData.dataDefault.viewMode == 'view' ||
                      item.isDisable) &&
                    !mData.mapDatas[item.code]
                  "
                >
                  {{ aLang.SurveyResultUser_no_data_message }}
                </template>

                <template v-else>
                  <mapbox-component
                    @update="fn_getDataFromMapboxComponent"
                    @selectedSearchItem="fn_disableSubmit"
                    :cordinatesValue="mData.mapDatas[item.code]"
                    :disabled="
                      mData.dataDefault.viewMode == 'detail' ||
                      mData.dataDefault.viewMode == 'view' ||
                      item.isDisable
                    "
                    :id="item.code"
                  ></mapbox-component>
                </template>
              </el-form-item>
            </b-col>
            <b-col
              class="survey-item"
              v-if="
                item.inputControl === 'file' &&
                mData.visibleSurveyItem[item.code]
              "
            >
              <el-form-item :label="item.title">
                <template
                  v-if="
                    (mData.dataDefault.viewMode == 'detail' ||
                      mData.dataDefault.viewMode == 'view' ||
                      item.isDisable) &&
                    mData.imageUploadConditions[item.code].fileList.length == 0
                  "
                >
                  {{ aLang.SurveyResultUser_no_data_message }}
                </template>
                <template v-else>
                  <el-upload
                    :disabled="
                      mData.dataDefault.viewMode == 'detail' ||
                      mData.dataDefault.viewMode == 'view' ||
                      item.isDisable
                    "
                    :id="item.code"
                    :accept="item.fileAccept"
                    action
                    :class="
                      mData.imageUploadConditions[item.code].fileList.length > 0
                        ? 'hidden-icon-upload'
                        : ''
                    "
                    :auto-upload="false"
                    :file-list="mData.imageUploadConditions[item.code].fileList"
                    :limit="mData.imageUploadConditions[item.code].limit"
                    :on-change="(event) => fn_onChangeFile(event, item)"
                    :list-type="
                      mData.imageUploadConditions[item.code].isPhoto === true
                        ? 'picture-card'
                        : ''
                    "
                    :on-preview="(event) => fn_onPreviewImage(event, item)"
                    :on-remove="(even) => fn_onRemoveFile(item)"
                  >
                    <i class="el-icon-plus"></i>
                  </el-upload>
                </template>
              </el-form-item>
              <el-dialog
                :visible.sync="
                  mData.imageUploadConditions[item.code].dialogVisible
                "
                width="30%"
              >
                <div>
                  <img
                    class="w-100"
                    :src="mData.imageUploadConditions[item.code].dialogImageUrl"
                  />
                </div>
                <span slot="footer" class="dialog-footer">
                  <el-button
                    @click="
                      mData.imageUploadConditions[
                        item.code
                      ].dialogVisible = false
                    "
                    >{{ aLang.c_close }}</el-button
                  >
                </span>
              </el-dialog>
            </b-col>
          </b-row>
          <b-row
            class="justify-content-center fixed-bottom2 button-padding survey-send-button"
            v-if="
              mData.dataDefault.viewMode == 'create' ||
              mData.dataDefault.viewMode == 'update'
            "
          >
            <b-col>
              <el-button
                type="success"
                class="btn-block"
                v-ladda
                @click="fn_submitForm"
                :disabled="isSearchLocation"
                >{{
                  mData.dataForm.survey &&
                  mData.dataForm.survey.config &&
                  mData.dataForm.survey.config.public &&
                  mData.dataForm.survey.config.public.buttonLabel
                    ? mData.dataForm.survey.config.public.buttonLabel
                    : aLang.SurveyResultUser_button_send_label
                }}
              </el-button>
            </b-col>
          </b-row>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
import LanguageService from "../../../service/LanguageService";
import MethodService from "../../../service/MethodService";
import SurveyModel from "./SurveyModel";
import SurveyApi from "../../../moduleApi/SurveyApi";
import PrefillApi from "../../../moduleApi/PrefillApi";
import SurveyItemApi from "../../../moduleApi/SurveyItemApi";
import ValidService from "../../../service/ValidService";
import SurveyResultApi from "../../../moduleApi/SurveyResultApi";
import mushroom from "../../../service/mushroom.api.def";
import EditorComponent from "../../../component/EditorComponent";
import ExtensionService from "../../../service/ExtensionService";
import "../../../assets/scss/layout/_surveyResult.scss";
import MapboxComponent from "../../../component/MapboxComponent";
import convertToHTML from "markdown-to-html-converter";

export default {
  components: { MapboxComponent, EditorComponent },
  data() {
    const lang =
      location.search.indexOf("lang=en") !== -1
        ? LanguageService.en
        : LanguageService.vi;
    return {
      aLang: lang,
      aElement: MethodService.element,
      formState: "loading",
      isSearchLocation: false,
      error: {
        title: lang.SurveyResultUser_error_title,
        message: lang.SurveyResultUser_error_no_internet,
      },
      mData: {
        dataDefault: {
          optionInputControls: {
            selectbox: {},
            checkbox: {},
            radio: {},
          },
          inputControls: ["checkbox", "selectbox", "radio"],
          dataParams: {},
          prefillData: {},
          listExpressionAndOperator: ["==", ">", "<", "!"],
          viewMode: "create",
        },
        dataForm: MethodService.copyObject(SurveyModel.dataForm),
        validForm: MethodService.copyObject(SurveyModel.validForm),
        dataFormRender: {},
        validFormRender: {},
        surveyItemInputControl: {},
        visibleSurveyItem: {},
        imageUploadConditions: {},
        mapDatas: {},
        arrayControlMap: [],
        waitData: {},
        objSurveyApiPrefillDatas: [],
        objSurveyApiDefault: [],
        surveyItemCodesCallApi: {},
        checkAll: {},
      },
    };
  },
  filters: {
    string: function (value) {
      return value.toString();
    },
  },
  updated: function () {
    //var _this = this;
    this.$nextTick(() => {
      //_this.mData.visibleSurveyItem = _this.fn_setConditionForSurveyItem(_this.mData.dataForm.surveyItems, _this.mData.dataFormRender, _this.mData.visibleSurveyItem)
      this.mData.visibleSurveyItem = this.fn_setConditionForSurveyItem(
        this.mData.dataForm.surveyItems,
        this.mData.dataFormRender,
        this.mData.visibleSurveyItem
      );
    });
  },
  methods: {
    async fn_onChangeFile(file, item) {
      let imageUploadConditions = MethodService.copyObject(
        this.mData.imageUploadConditions[item.code]
      );
      const isLt50MB = file.size / 1024 / 1024 < 50;
      if (!isLt50MB) {
        window.toastr.error(
          this.aLang.SurveyResultUser_error_exceed_limit_filesize
        );
        imageUploadConditions.fileList = [];
      } else {
        let fileTypeRaw = file.raw.type;
        fileTypeRaw = fileTypeRaw.split("/")[0];
        if (fileTypeRaw !== "image") {
          imageUploadConditions.isPhoto = false;
        }
        ExtensionService.upload(file, "user/upload")
          .then((res) => {
            item.fileId = res.result;
            this.mData.dataFormRender[item.code] = res.result;
            imageUploadConditions.fileList.push(file);
            imageUploadConditions.dialogImageUrl =
              ExtensionService.urlImg + res.result;
          })
          .catch((error) => {
            console.error(error);
            this.mData.dataDefault.imageUploadConditions[
              item.code
            ].fileList.forEach((el, i) => {
              if (el.uid == file.uid) {
                imageUploadConditions.fileList.splice(i, 1);
              }
            });
          });
      }
      this.mData.imageUploadConditions[item.code] = imageUploadConditions;
    },
    fn_onPreviewImage(file, item) {
      if (this.mData.imageUploadConditions[item.code].isPhoto) {
        if (!MethodService.isUndefined(file.url)) {
          this.mData.imageUploadConditions[item.code].dialogImageUrl = file.url;
        }
        this.mData.imageUploadConditions[item.code].dialogVisible = true;
      }
    },
    fn_onRemoveFile(item) {
      item.fileId = null;
      this.mData.imageUploadConditions[item.code].fileList = [];
      this.mData.imageUploadConditions[item.code].isPhoto = true;
      this.mData.dataFormRender[item.code] = "";
    },

    fn_convertMarkdownToHtml(content) {
      return convertToHTML(content);
    },

    //khoi tao form mac dinh
    async fn_initDataDefaultForm(surveyId) {
      let dataFormRender = {};
      let imageUploadConditions = {};
      let optionInputControls = MethodService.copyObject(
        this.mData.dataDefault.optionInputControls
      );
      let inputControls = MethodService.copyObject(
        this.mData.dataDefault.inputControls
      );
      let validFormRender = {};
      let visibleSurveyItem = {};

      //lay du lieu survey - surveyItem tu api
      let req_Survey = SurveyApi.findById(surveyId);
      let req_SurveyItem = SurveyItemApi.list({
        filters: "surveyId=" + surveyId,
      });
      let res_Survey = await req_Survey;
      let res_SurveyItem = await req_SurveyItem;
      this.mData.dataForm.survey = res_Survey.result ? res_Survey.result : {};
      let surveyItems = res_SurveyItem.result ? res_SurveyItem.result : [];

      try {
        document.title = this.mData.dataForm.survey.name;
        let styleDom = document.querySelector(
          'div[data-survey-id="' + surveyId + '"]'
        );
        if (styleDom) styleDom.remove();
        if (
          this.mData.dataForm.survey &&
          this.mData.dataForm.survey.config &&
          this.mData.dataForm.survey.config.public &&
          this.mData.dataForm.survey.config.public.cssInject
        ) {
          styleDom = document.createElement("style");
          styleDom.setAttribute("data-survey-id", surveyId);
          styleDom.innerHTML =
            this.mData.dataForm.survey.config.public.cssInject;
          document.body.appendChild(styleDom);
        }
      } catch (e) {
        console.error(e);
      }

      //gan default cho surveyItem co input control = file de render
      surveyItems.map((item) => {
        if (item.inputControl !== "image" && item.inputControl !== "label") {
          if (
            item.inputControl === "checkbox" ||
            (item.inputControl === "selectbox" && item.isMultipleValue)
          ) {
            dataFormRender[item.code] = [];
          } else {
            dataFormRender[item.code] = null;
          }
          if (inputControls.includes(item.inputControl)) {
            optionInputControls[item.inputControl][item.code] = [];
          }
          if (item.inputControl == "file") {
            imageUploadConditions[item.code] = {
              limit: 1,
              isPhoto: true,
              dialogImageUrl: null,
              dialogVisible: false,
              fileList: [],
            };
          }
        }
        if (typeof item.label == "string") item.label = item.label.trim();
        visibleSurveyItem[item.code] = true;
        validFormRender[item.code] = this.fn_setValidDefaultForSurveyItem(item);
        if (item.map && item.map.center.length > 0) {
          item.map.center.forEach((i) => {
            i["idFieldFlyToMap"] = item.id;
            i["codeFiledFlyToMap"] = item.code;
          });
          this.mData.arrayControlMap = this.mData.arrayControlMap.concat(
            item.map.center
          );
        }
      });

      surveyItems.map((item) => {
        item.arrayFieldsControlMap = [];
        this.mData.arrayControlMap.forEach((arrItem) => {
          if (arrItem.code === item.id) {
            item.arrayFieldsControlMap.push(arrItem);
          }
        });
      });

      if (
        this.mData.dataDefault.dataParams.prefillData ||
        this.mData.dataDefault.dataParams.prefillId
      ) {
        let prefillData = this.mData.dataDefault.dataParams.prefillData;
        if (this.mData.dataDefault.dataParams.prefillId) {
          let resp = await PrefillApi.findById(
            this.mData.dataDefault.dataParams.prefillId
          );
          prefillData = resp.result.data;
        }
        let resultParam = MethodService.decode(prefillData);
        resultParam = JSON.parse(resultParam);
        this.mData.mapDatas = this.fn_setValueToMapComponent(
          surveyItems,
          resultParam
        );
      }
      //gan lai du lieu cho mData
      this.mData.dataFormRender = dataFormRender;
      this.mData.dataForm.surveyItems = surveyItems;
      this.mData.dataDefault.optionInputControls = optionInputControls;
      this.mData.validFormRender = validFormRender;
      this.mData.imageUploadConditions = imageUploadConditions;
      this.mData.visibleSurveyItem = visibleSurveyItem;

      try {
        if (
          this.mData.dataForm.survey &&
          this.mData.dataForm.survey.config &&
          this.mData.dataForm.survey.config.public &&
          this.mData.dataForm.survey.config.public.jsInject
        ) {
          eval(this.mData.dataForm.survey.config.public.jsInject);
        }
      } catch (e) {
        console.error(e);
      }
    },

    fn_setConditionForSurveyItem(
      surveyItems,
      dataFormRender,
      visibleSurveyItem
    ) {
      //var _this = this;
      surveyItems.forEach((item) => {
        if (
          !MethodService.isUndefined(item.condition) &&
          !MethodService.isNull(item.condition)
        ) {
          let condition = item.condition;
          let operatorDefaultValue = "==";
          let surveyItemCodeCondition = condition.substring(
            condition.indexOf("{") + 1,
            condition.indexOf("}")
          );
          let conditionValue = condition.substring(
            condition.indexOf(operatorDefaultValue) +
              operatorDefaultValue.length,
            condition.length
          );
          if (
            MethodService.isUndefined(
              dataFormRender[surveyItemCodeCondition]
            ) ||
            MethodService.isNull(dataFormRender[surveyItemCodeCondition]) ||
            MethodService.isEmptyArray(dataFormRender[surveyItemCodeCondition])
          ) {
            visibleSurveyItem[item.code] = false;
          } else {
            visibleSurveyItem[item.code] = conditionValue.includes(
              dataFormRender[surveyItemCodeCondition]
            );
          }
        } else {
          visibleSurveyItem[item.code] = true;
        }
        if (!visibleSurveyItem[item.code]) {
          if (item.defaultValue) {
            //dataFormRender[item.code] = _this.fn_setDefaultValueForItem(item)
            dataFormRender[item.code] = this.fn_setDefaultValueForItem(item);
          } else {
            if (
              item.inputControl == "checkbox" ||
              (item.inputControl == "selectbox" && item.isMultipleValue)
            ) {
              dataFormRender[item.code] = [];
            } else {
              dataFormRender[item.code] = null;
            }
          }
        }
      });
      return visibleSurveyItem;
    },

    //lay option value
    fn_getOptionValue(item) {
      let optionValue = [];
      let objSurveyApiDefault = MethodService.copyObject(
        this.mData.objSurveyApiDefault
      );
      try {
        if (item.dataSource.type != "api") {
          let arrSplit = JSON.parse(item.dataSource.value);
          for (let key in arrSplit) {
            arrSplit[key] = arrSplit[key].trim();
          }
          optionValue = this.fn_convertJsonToKeyValueOption(arrSplit);
        } else {
          let requestApi = item.dataSource.requestApi;
          if (
            !MethodService.isUndefined(requestApi) ||
            !MethodService.isNull(requestApi)
          ) {
            if (
              MethodService.isUndefined(requestApi.surveyItemCode) ||
              MethodService.isEmptyArray(requestApi.surveyItemCode)
            ) {
              let queryString = new URLSearchParams(location.search);
              let objRequest = {
                url:
                  "https:" +
                  requestApi.url.replace(/\{(\w+)\}/g, (match, g1) =>
                    queryString.has(g1) ? queryString.get(g1) : ""
                  ),
                method: requestApi.method,
                headers: requestApi.headers,
                body: requestApi.body,
              };
              if (requestApi.mappingFields) {
                objRequest["mappingFields"] = requestApi.mappingFields;
              }
              objSurveyApiDefault.push({
                surveyItemCode: item.code,
                optionType: item.inputControl,
                objRequest: objRequest,
              });
              optionValue = [];
            }
          }
        }
        this.mData.objSurveyApiDefault = objSurveyApiDefault;
        return optionValue;
      } catch (e) {
        window.toastr.error("Dữ liệu truyền vào không chính xác");
        console.log("Error parse prefillData: ", e);
      }
    },

    // set validDefault cho surveyItem
    fn_setValidDefaultForSurveyItem(item) {
      let valid = [];
      if (item.validation.required) {
        valid.push(ValidService.required);
      }
      if (
        item.validation.length > 0 ||
        item.validation.minLength > 0 ||
        item.validation.maxLength > 0
      ) {
        valid.push(
          ValidService.checkLength(
            item.validation.minLength ? item.validation.minLength : null,
            item.validation.maxLength ? item.validation.maxLength : null
          )
        );
      }
      if (item.validation.pattern) {
        valid.push(
          ValidService.checkPattern(
            item.validation.pattern,
            item.validation.patternMessage
          )
        );
      }

      if (item.inputControl === "email") {
        valid.push(ValidService.checkEmail);
      }
      return valid;
    },

    // chuyen chuoi json thanh kieu key-value cho Option
    fn_convertJsonToKeyValueOption(json) {
      let valueOption = [];
      for (let key in json) {
        valueOption.push({
          key: key,
          value: json[key],
        });
      }
      return valueOption;
    },

    // gui thong tin
    fn_submitForm() {
      this.$refs["myForm"].validate((valid, invalidField) => {
        if (valid) {
          setTimeout(async () => {
            let result = this.fn_getSurveyResults();
            if (this.mData.dataDefault.viewMode == "create") {
              let formData = {
                surveyId: this.mData.dataForm.survey.id,
                result: result,
                callbackUrl: this.mData.dataDefault.dataParams.callbackUrl,
                appCode: this.mData.dataDefault.dataParams.appCode,
              };
              let res;
              try {
                res = await SurveyResultApi.create(
                  formData,
                  this.mData.dataDefault.dataParams
                );
              } catch (e) {
                console.error(e);
                //window.toastr.error("Có lỗi trong quá trình gửi thông tin, có thể đang có sự cố mạng. Bạn hãy thử lại sau ít phút!");
                return;
              }

              if (res.result) {
                if (
                  !MethodService.isNull(formData.callbackUrl) &&
                  formData.callbackUrl !== ""
                ) {
                  window.location.href = formData.callbackUrl;
                } else {
                  this.$router.push({
                    name: "Client-Survey-Result-Successful",
                    query: {
                      lang:
                        location.search.indexOf("lang=en") !== -1 ? "en" : "vi",
                    },
                  });
                }
              }
              this.fn_resetForm();
              MethodService.stopLadda();
            }
            if (this.mData.dataDefault.viewMode == "update") {
              let formData = {
                id: this.mData.dataDefault.dataParams.id,
                surveyId: this.mData.dataForm.survey.id,
                result: result,
                callbackUrl: this.mData.dataDefault.dataParams.callbackUrl,
                appCode: this.mData.dataDefault.dataParams.appCode,
                surveyToken: this.mData.dataDefault.prefillData.surveyToken,
              };
              let params = MethodService.copyObject(
                this.mData.dataDefault.dataParams
              );
              params.surveyToken =
                this.mData.dataDefault.prefillData.surveyToken;
              let res;
              try {
                res = await SurveyResultApi.update(formData, params);
              } catch (e) {
                console.error(e);
                //window.toastr.error("Có lỗi trong quá trình gửi thông tin, có thể đang có sự cố mạng. Bạn hãy thử lại sau ít phút!");
                return;
              }

              if (res.result) {
                if (
                  !MethodService.isNull(formData.callbackUrl) &&
                  formData.callbackUrl !== ""
                ) {
                  window.location.href = formData.callbackUrl;
                } else {
                  this.$router.push({
                    name: "Client-Survey-Result-Successful",
                    query: {
                      lang:
                        location.search.indexOf("lang=en") !== -1 ? "en" : "vi",
                    },
                  });
                }
              }
            }
          }, 1000);
        } else {
          let focusFieldKey = Object.keys(invalidField)[0];
          this.$refs["myForm"].$el.querySelector("#" + focusFieldKey).focus();
          MethodService.stopLadda();
          // window.toastr.error(this.aLang.SurveyResultUser_error_invalid_input)
          return false;
        }
      });
    },
    fn_getUrlImageById(id) {
      return ExtensionService.urlImg + id;
    },

    fn_resetForm() {
      this.$refs["myForm"].resetFields();
    },

    //lay ra list inputControl cua surveyItem
    fn_getSurveyItemInputControls() {
      let surveyItems = MethodService.copyObject(
        this.mData.dataForm.surveyItems
      );
      let surveyItemInputControls = {};
      surveyItems.map((item) => {
        surveyItemInputControls[item.code] = item.inputControl;
      });
      return surveyItemInputControls;
    },

    //lay ra danh sach surveyResult
    fn_getSurveyResults() {
      let dataFormRender = MethodService.copyObject(this.mData.dataFormRender);
      let mapDataObject = MethodService.copyObject(
        this.mData.dataForm.mapDataObject
      );
      let keyItems = Object.keys(dataFormRender);
      let surveyItemInputControls = this.fn_getSurveyItemInputControls();
      return keyItems.map((item) => {
        let value = dataFormRender[item];
        if (MethodService.isUndefined(value) || MethodService.isNull(value)) {
          value = "";
        }
        if (MethodService.isString(value)) {
          value = value.trim();
        }
        if (MethodService.isArray(value)) {
          if (value.length > 1) {
            value = value.join("\n");
          } else {
            value = value.toString();
          }
        }
        let obj = {
          code: item,
          value: value,
        };
        if (surveyItemInputControls[item] == "map") {
          obj = {
            code: item,
            value: mapDataObject.value.toString(),
            //data: mapDataObject.geoJson,
          };
        }
        return obj;
      });
    },

    fn_convertArrayToString(value) {
      if (value == null || value === "undefined") return "";
      return value.join();
    },

    fn_isArrayOrUndefined(value) {
      return MethodService.isArray(value) || MethodService.isUndefined(value);
    },

    // truyen du lieu mac dinh tu prefillData vao form
    fn_setValueFromPrefillData(resultParam, surveyItems) {
      let dataFormRender = MethodService.copyObject(this.mData.dataFormRender);
      let surveyItemCodesCallApi = {};
      let objSurveyApiPrefillDatas = [];
      for (let item in resultParam) {
        let val = resultParam[item];
        dataFormRender[item] = val ? val : dataFormRender[item];
      }
      surveyItems.forEach((element) => {
        if (element.inputControl === "checkbox") {
          if (resultParam[element.code]) {
            dataFormRender[element.code] =
              resultParam[element.code].split("\n");
            if (this.fn_isSurveyItemCallApi(element)) {
              dataFormRender[element.code] = [];
              surveyItemCodesCallApi[element.code] =
                resultParam[element.code].split("\n");
            }
          }
        }
        if (element.inputControl === "selectbox" && element.isMultipleValue) {
          if (resultParam[element.code]) {
            dataFormRender[element.code] =
              resultParam[element.code].split("\n");
            surveyItemCodesCallApi[element.code] =
              resultParam[element.code].split("\n");
          }
        }
        if (
          (element.inputControl === "radio" ||
            element.inputControl === "selectbox") &&
          !element.isMultipleValue
        ) {
          if (resultParam[element.code]) {
            if (this.fn_isSurveyItemCallApi(element)) {
              dataFormRender[element.code] = null;
              surveyItemCodesCallApi[element.code] = resultParam[element.code];
            }
          }
        }
        if (element.inputControl === "file") {
          let valueImage = [];
          if (resultParam[element.code]) {
            let data = {
              id: resultParam[element.code],
              name: resultParam[element.code],
              url: ExtensionService.urlImg + resultParam[element.code],
            };
            valueImage.push(data);
            this.mData.imageUploadConditions[element.code].fileList =
              valueImage;
          }
        }
      });
      this.mData.dataFormRender = dataFormRender;
      this.mData.objSurveyApiPrefillDatas = objSurveyApiPrefillDatas;
      this.mData.surveyItemCodesCallApi = surveyItemCodesCallApi;
    },
    fn_isSurveyItemCallApi(surveyItem) {
      return (
        !MethodService.isUndefined(surveyItem.dataSource) &&
        !MethodService.isNull(surveyItem.dataSource) &&
        surveyItem.dataSource.type == "api"
      );
    },
    fn_setDefaultValueForItem(item) {
      let value = item.defaultValue;
      if (item.inputControl === "checkbox") {
        value = value.split("\n");
      }
      if (item.inputControl === "selectbox" && item.isMultipleValue) {
        value = value.split("\n");
      }
      return value;
    },
    //set value default cho form
    async fn_setValueDeFaultForm() {
      let dataFormRender = MethodService.copyObject(this.mData.dataFormRender);
      let optionInputControls = MethodService.copyObject(
        this.mData.dataDefault.optionInputControls
      );
      let inputControls = MethodService.copyObject(
        this.mData.dataDefault.inputControls
      );
      let surveyItems = MethodService.copyObject(
        this.mData.dataForm.surveyItems
      );
      let visibleSurveyItem = MethodService.copyObject(
        this.mData.visibleSurveyItem
      );
      surveyItems.map((item) => {
        if (item.defaultValue) {
          dataFormRender[item.code] = this.fn_setDefaultValueForItem(item);
        }
        if (inputControls.includes(item.inputControl)) {
          optionInputControls[item.inputControl][item.code] =
            this.fn_getOptionValue(item);
        }
      });
      visibleSurveyItem = this.fn_setConditionForSurveyItem(
        surveyItems,
        dataFormRender,
        visibleSurveyItem
      );
      this.mData.dataDefault.optionInputControls = optionInputControls;
      this.mData.dataFormRender = dataFormRender;
      this.mData.visibleSurveyItem = visibleSurveyItem;
      if (
        this.mData.dataDefault.dataParams.prefillData ||
        this.mData.dataDefault.dataParams.prefillId
      ) {
        let prefillData = this.mData.dataDefault.dataParams.prefillData;
        if (this.mData.dataDefault.dataParams.prefillId) {
          let resp = await PrefillApi.findById(
            this.mData.dataDefault.dataParams.prefillId
          );
          prefillData = resp.result.data;
        }
        let resultParam = MethodService.decode(prefillData);
        try {
          resultParam = JSON.parse(resultParam);
          this.mData.dataDefault.prefillData = resultParam;
        } catch (e) {
          window.toastr.error("Lỗi dữ liệu đầu vào");
        }
        if (resultParam) {
          this.fn_setValueFromPrefillData(resultParam, surveyItems);
        } else {
          window.toastr.error("Lỗi dữ liệu đầu vào");
        }
      }
    },

    //lay ra va cap nhat du lieu khi vi tri tren ban do thay doi
    fn_getDataFromMapboxComponent(value) {
      this.mData.dataForm.mapDataObject = value;
    },

    fn_disableSubmit(data) {
      if (!data || data.mode !== "search") return;

      clearTimeout(this.threadEnableSubmit);
      this.isSearchLocation = true;
      this.threadEnableSubmit = setTimeout(() => {
        this.isSearchLocation = false;
      }, 4000);
    },

    // phuong thuc lay du lieu tu ben api thu 3
    async fn_getKeyValueFromApi(objectRequest) {
      let keyValueDataResult = [];
      let resp_data = await SurveyResultApi.getDataFromUrl(
        objectRequest.url,
        objectRequest.method,
        objectRequest.headers,
        objectRequest.body
      );
      let dataResult = resp_data.result ? resp_data.result : [];
      let mappedFields = objectRequest.mappingFields;
      dataResult.map((item) => {
        if (mappedFields) {
          keyValueDataResult.push({
            key: item[mappedFields.key],
            value: item[mappedFields.value],
            data: item[mappedFields.data],
          });
        } else {
          keyValueDataResult.push({
            key: item.key,
            value: item.value,
            data: item.data,
          });
        }
      });
      return keyValueDataResult;
    },

    // phương thức thực hiện khi tick vào checkbox Check All
    fn_checkAll(code) {
      const options = this.mData.dataDefault.optionInputControls.checkbox[code];
      if (!this.mData.checkAll[code]) {
        this.mData.dataFormRender[code] = [];
      } else if (Array.isArray(options)) {
        this.mData.dataFormRender[code] = options.map((opt) => opt.key);
      }
    },

    //thay doi option select box  request api
    fn_handleChangeOption(item) {
      const code = item.code;
      var _this = this;
      let surveyItems = MethodService.copyObject(
        this.mData.dataForm.surveyItems
      );
      // let surveyItemNotAPI = surveyItems.find(item => item.code == code && item.dataSource.type != 'api');
      // if (!MethodService.isUndefined(surveyItemNotAPI)) {
      //   return;
      // }
      let dataFormRender = MethodService.copyObject(this.mData.dataFormRender);
      item.arrayFieldsControlMap.forEach(
        (i) => (i.idFieldChange = dataFormRender[item.code])
      );
      let optionInputControls = MethodService.copyObject(
        this.mData.dataDefault.optionInputControls
      );
      let inputControls = MethodService.copyObject(
        this.mData.dataDefault.inputControls
      );
      let surveyItemReferences = surveyItems.filter(
        (item) =>
          !MethodService.isUndefined(item.dataSource) &&
          !MethodService.isUndefined(item.dataSource.requestApi) &&
          !MethodService.isNull(item.dataSource.requestApi) &&
          !MethodService.isUndefined(
            item.dataSource.requestApi.surveyItemCode
          ) &&
          !MethodService.isEmptyArray(
            item.dataSource.requestApi.surveyItemCode
          ) &&
          item.dataSource.requestApi.surveyItemCode.includes(code)
      );
      // if (MethodService.isEmptyArray(surveyItemReferences)) {
      //   return;
      // }
      let promise = surveyItemReferences.map(async (surveyItemReference) => {
        _this.fn_clearOptionReference(
          dataFormRender,
          optionInputControls,
          surveyItems,
          surveyItemReference
        );
        dataFormRender[surveyItemReference.code] = null;
        let requestApi = surveyItemReference.dataSource.requestApi;
        let url = requestApi.url;
        requestApi.surveyItemCode.forEach((itemCode) => {
          if (dataFormRender[itemCode]) {
            url = url.replace("{" + itemCode + "}", dataFormRender[itemCode]);
          } else {
            url = url.replace("{" + itemCode + "}", "");
          }
        });
        let objRequest = {
          url: url,
          method: requestApi.method,
          headers: requestApi.headers,
          body: requestApi.body,
        };
        if (requestApi.mappingFields) {
          objRequest["mappingFields"] = requestApi.mappingFields;
        }
        if (inputControls.includes(surveyItemReference.inputControl)) {
          optionInputControls[surveyItemReference.inputControl][
            surveyItemReference.code
          ] = await this.fn_getKeyValueFromApi(objRequest);
        }
      });
      Promise.all(promise).then(() => {
        _this.mData.dataFormRender = dataFormRender;
        _this.mData.dataDefault.optionInputControls = optionInputControls;
      });

      // control map
      if (item.arrayFieldsControlMap.length === 0) return;
      if (
        (item.inputControl === "selectbox" && !item.isMultipleValue) ||
        item.inputControl === "radio"
      ) {
        item.arrayFieldsControlMap.forEach((field) => {
          this.mData.dataDefault.optionInputControls[item.inputControl][
            item.code
          ].forEach((i) => {
            if (field.idFieldChange === i.key) {
              this.mData.mapDatas[field.codeFiledFlyToMap] = [
                i.data[field.lng],
                i.data[field.lat],
              ];
            }
          });
        });
      } else if (
        item.inputControl === "textbox" &&
        item.textboxType === "text"
      ) {
        const coordinates = dataFormRender[item.code]
          .split(",")
          .map((coor) => +coor);

        if (coordinates.length !== 2) return;
        if (coordinates[0] < -180 || coordinates[0] > 180) return;
        if (coordinates[1] < -90 || coordinates[1] > 90) return;

        item.arrayFieldsControlMap.forEach((field) => {
          this.mData.mapDatas[field.codeFiledFlyToMap] = coordinates;
        });
      }
    },
    fn_clearOptionReference(
      dataFormRender,
      optionInputControls,
      surveyItems,
      surveyItemChange
    ) {
      let surveyItemReferences = surveyItems.filter(
        (item) =>
          !MethodService.isUndefined(item.dataSource) &&
          !MethodService.isUndefined(item.dataSource.requestApi) &&
          !MethodService.isNull(item.dataSource.requestApi) &&
          !MethodService.isUndefined(
            item.dataSource.requestApi.surveyItemCode
          ) &&
          !MethodService.isEmptyArray(
            item.dataSource.requestApi.surveyItemCode
          ) &&
          item.dataSource.requestApi.surveyItemCode.includes(
            surveyItemChange.code
          )
      );
      surveyItemReferences.map((surveyItemReference) => {
        dataFormRender[surveyItemReference.code] = null;
        optionInputControls[surveyItemReference.inputControl][
          surveyItemReference.code
        ] = [];
      });
    },
    fn_setValueToMapComponent(surveyItems, resultParam) {
      let mapDatas = {};
      surveyItems.map((item) => {
        if (item.inputControl == "map") {
          if (
            !MethodService.isUndefined(resultParam[item.code]) &&
            !MethodService.isNull(resultParam[item.code]) &&
            !MethodService.isEmptyString(resultParam[item.code])
          ) {
            mapDatas[item.code] = resultParam[item.code]
              .split(",")
              .map((cordinateItem) => +cordinateItem);
          }
        }
      });
      return mapDatas;
    },
    fn_setPromiseSurveyItemApi(
      surveyItems,
      prefillData,
      surveyItemCodesCallApi
    ) {
      let objSurveyApiPrefillDatas = [];
      let dataFormRender = MethodService.copyObject(this.mData.dataFormRender);
      surveyItems.map((element) => {
        if (
          element.dataSource &&
          element.dataSource.type == "api" &&
          element.dataSource.requestApi
        ) {
          if (
            surveyItemCodesCallApi[element.dataSource.requestApi.surveyItemCode]
          ) {
            let requestApi = element.dataSource.requestApi;
            let url = requestApi.url;
            requestApi.surveyItemCode.forEach((itemCode) => {
              url = url.replace(
                "{" + itemCode + "}",
                surveyItemCodesCallApi[itemCode]
              );
            });
            let objRequest = {
              url: url,
              method: requestApi.method,
              headers: requestApi.headers,
              body: requestApi.body,
            };
            if (requestApi.mappingFields) {
              objRequest["mappingFields"] = requestApi.mappingFields;
            }

            objSurveyApiPrefillDatas.push({
              surveyItemCode: element.code,
              optionType: element.inputControl,
              objRequest: objRequest,
            });
          }
        }
      });
      // xu ly call api bat dong bo
      let promiseApiDefault = null;
      let promiseApiPrefillDatas = null;
      var _this = this;
      let optionInputControls = MethodService.copyObject(
        this.mData.dataDefault.optionInputControls
      );
      if (!MethodService.isEmptyArray(this.mData.objSurveyApiDefault)) {
        let objSurveyApiDefault = MethodService.copyObject(
          this.mData.objSurveyApiDefault
        );
        promiseApiDefault = objSurveyApiDefault.map(async (item) => {
          optionInputControls[item.optionType][item.surveyItemCode] =
            await this.fn_getKeyValueFromApi(item.objRequest);
        });
      }
      if (!MethodService.isEmptyArray(objSurveyApiPrefillDatas)) {
        promiseApiPrefillDatas = objSurveyApiPrefillDatas.map(async (item) => {
          optionInputControls[item.optionType][item.surveyItemCode] =
            await this.fn_getKeyValueFromApi(item.objRequest);
        });
      }
      if (
        !MethodService.isNull(promiseApiPrefillDatas) ||
        !MethodService.isNull(promiseApiDefault)
      ) {
        Promise.all(promiseApiDefault, promiseApiPrefillDatas).then(() => {
          surveyItems.map((element) => {
            if (element.inputControl === "checkbox") {
              if (prefillData[element.code]) {
                dataFormRender[element.code] =
                  prefillData[element.code].split("\n");
              }
            }
            if (
              element.inputControl === "selectbox" &&
              element.isMultipleValue
            ) {
              if (prefillData[element.code]) {
                dataFormRender[element.code] =
                  prefillData[element.code].split("\n");
              }
            }
            if (
              (element.inputControl === "radio" ||
                element.inputControl === "selectbox") &&
              !element.isMultipleValue
            ) {
              if (prefillData[element.code]) {
                dataFormRender[element.code] = prefillData[element.code];
              }
            }
          });
          _this.mData.dataFormRender = dataFormRender;
          _this.mData.dataDefault.optionInputControls = optionInputControls;
        });
      } else {
        surveyItems.map((element) => {
          if (element.inputControl === "checkbox") {
            if (prefillData[element.code]) {
              dataFormRender[element.code] =
                prefillData[element.code].split("\n");
            }
          }
          if (element.inputControl === "selectbox" && element.isMultipleValue) {
            if (prefillData[element.code]) {
              dataFormRender[element.code] =
                prefillData[element.code].split("\n");
            }
          }
          if (
            (element.inputControl === "radio" ||
              element.inputControl === "selectbox") &&
            !element.isMultipleValue
          ) {
            if (prefillData[element.code]) {
              dataFormRender[element.code] = prefillData[element.code];
            }
          }
        });
        _this.mData.dataFormRender = dataFormRender;
        _this.mData.dataDefault.optionInputControls = optionInputControls;
      }
    },
    fn_isArray(value) {
      return MethodService.isArray(value);
    },
  },
  async created() {
    try {
      let query = MethodService.copyObject(this.$router.currentRoute.query);
      this.mData.dataDefault.dataParams = query;
      this.mData.dataDefault.viewMode = query.viewMode;
      let validateHashCodeResult = await mushroom.survey.validateHashCode(
        query
      );
      if (!validateHashCodeResult.result) {
        this.formState = "error";
        this.error.message = `${this.aLang.SurveyResultUser_error_invalid_data}\n\n${this.aLang.SurveyResultUser_error_technical_detail}: hashCode is mismatched`;
        return;
      }
    } catch (e) {
      this.formState = "error";
      return;
    }

    if (!this.$router.currentRoute.params.id) {
      //window.toastr.error("Lỗi dữ liệu đầu vào");
      this.formState = "error";
      this.error.message = `${this.aLang.SurveyResultUser_error_invalid_data}\n\n${this.aLang.SurveyResultUser_error_technical_detail}: mising id`;
      return;
    }

    try {
      await this.fn_initDataDefaultForm(this.$router.currentRoute.params.id);
    } catch (e) {
      console.error(e);
      this.formState = "error";
      this.error.message = `${this.aLang.SurveyResultUser_error_no_internet}\n\n${this.aLang.SurveyResultUser_error_technical_detail}: code: ${e.code}, subCode: ${e.subCode}`;
      return;
    }

    this.formState = "shown";

    try {
      await this.fn_setValueDeFaultForm();
      this.fn_setPromiseSurveyItemApi(
        this.mData.dataForm.surveyItems,
        this.mData.dataDefault.prefillData,
        this.mData.surveyItemCodesCallApi
      );
    } catch (e) {
      //this.formState = "error";
      window.toastr.error("Đã có lỗi xảy ra");
      return;
    }
  },

  mounted: function () {},
};
</script>

<style lang="scss" scoped>
#form-survey {
  @media screen and (min-width: 800px) {
    padding: 15px 0;
  }

  .card {
    max-width: 700px;
    margin-left: auto;
    margin-right: auto;
    .card-body {
      padding: 15px;
    }
  }

  .survey-name {
    text-align: center;
  }

  .survey-description {
    .survey-description-holder {
      margin: 0 auto;
      max-width: 590px;
      //padding-left: 15px;
      //padding-right: 15px;
      white-space: pre-wrap;

      &:empty {
        display: none;
      }
    }
  }

  .survey-item {
    margin: 0 auto;
    max-width: 590px;
  }

  .survey-send-button {
    //position: sticky;
    //bottom: 5px;
    //z-index: 300;
    margin: 15px auto 0;
    width: 320px;
    max-width: 100%;
  }
}
</style>
